import { useState } from 'react';
import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import BulkSelectSerial from './BulkSelectSerial';
import { IFloatSelectSerialItem } from '../../FloatSelectSerial';

interface IBulkSelectSerialModal {
  isOpen: boolean;
  onClose: () => void;
  items: IFloatSelectSerialItem[];
  onSuccess: () => void;
  requiredUnits: number;
}

/**
 * Modal para la selección masiva de seriales de stock
 * @param isOpen - Controla la visibilidad del modal
 * @param onClose - Función para cerrar el modal
 * @param items - Lista de items disponibles para reservar
 * @param onSuccess - Callback ejecutado al completar la reserva exitosamente
 * @param requiredUnits - Número de unidades requeridas para la reserva
 */
const BulkSelectSerialModal = ({ isOpen, onClose, items, onSuccess, requiredUnits }: IBulkSelectSerialModal) => {
  const [shouldCloseModal, setShouldCloseModal] = useState(false);

  const handleSuccess = () => {
    setShouldCloseModal(true);
    onSuccess();
  };

  if (!isOpen) return null;

  return (
    <NudosGenericModal
      customClassName="relative"
      shouldCloseModal={shouldCloseModal}
      closesOnClickOutside={false}
      closeModalCallback={onClose}
      modalContent={
        <NudosModalContent
          modalContentTitle="Reservar todas las unidades del stock"
          toCloseModal={() => setShouldCloseModal(true)}
          CustomModalComponent={
            <BulkSelectSerial items={items} onSuccess={handleSuccess} requiredUnits={requiredUnits} />
          }
          customWidth="780px"
          customHeight="680px"
        />
      }
    />
  );
};

export default BulkSelectSerialModal;
